<template>
    <div>
        <section class="relative min-h-screen bg-gradient-to-r from-green-700 via-teal-400 to-green-900 text-white overflow-hidden">
            <!-- Subtle Background Pattern -->
            <div class="absolute inset-0 bg-black/10"></div>
            
            <!-- Content -->
            <div class="relative max-w-7xl mx-auto px-5 sm:px-10 md:px-12 lg:px-5 py-24">
                <div class="grid lg:grid-cols-2 items-center gap-12 lg:gap-16 min-h-[80vh]">
                    <!-- Text Content -->
                    <div class="space-y-6" data-aos="fade-right" data-aos-duration="1000">
                        <!-- Badge -->
                        <div class="inline-flex items-center px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm">
                            <span class="w-2 h-2 bg-white rounded-full mr-2"></span>
                            Environmental Excellence
                        </div>
                        
                        <!-- Main Heading -->
                        <h1 class="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white">
                            Leading Environmental
                            <br>
                            <span class="text-teal-100">Solutions</span>
                        </h1>
                        
                        <!-- Description -->
                        <p class="text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl">
                            Enhancing the positive impacts through innovative assessment and monitoring solutions.
                        </p>
                        
                        <!-- CTA Button -->
                        <div class="pt-4">
                            <router-link to="/Contact" 
                                class="inline-flex items-center px-8 py-4 bg-white text-green-800 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg">
                                Get a Quote
                                <svg class="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                                </svg>
                            </router-link>
                        </div>
                    </div>
                    
                    <!-- Image Content -->
                    <div class="relative" data-aos="fade-left" data-aos-duration="1000">
                        <!-- Simple Image Container -->
                        <div class="relative rounded-2xl overflow-hidden shadow-2xl">
                            <img :src="HeroImage" 
                                 class="w-full h-[400px] md:h-[500px] object-cover" 
                                 alt="Environmental Monitoring" />
                            
                            <!-- Subtle Overlay -->
                            <div class="absolute inset-0 bg-gradient-to-t from-green-900/30 to-transparent"></div>
                        </div>
                        
                        <!-- Simple Badge -->
                        <div class="absolute -bottom-6 left-6 bg-white rounded-xl px-6 py-3 shadow-lg">
                            <div class="text-green-800 font-semibold">Comprehensive Environmental Solutions</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default {
    data() {
        return {
            HeroImage: require('@/assets/water1.jpg')
        }
    }
}
</script>

<style scoped>
/* Custom animations and styles can be added here if needed */
</style>